import _ from 'lodash';
import { normalizeClassicLink } from './normalizeClassicLink';

const DESKTOP = 'DESKTOP';

let getMmc = config =>
  _.get(config, 'style.vehicleInfo.code').replace(/_.*/, '');
let getPeg = config =>
  _.get(config, 'style.vehicleInfo.code').replace(/^.+_/, '');
let getEngine = config => _.get(config, 'selections.engine');
let getExteriorColor = config => _.get(config, 'selections.exteriorColor');
let getInteriorColor = config => _.get(config, 'selections.interiorColor');
let getTrimvccode = config => _.get(config, 'style.vehicleInfo.code');
let getTrimDesc = config => _.get(config, 'style.trimName');
let getTransmission = config => _.get(config, 'selections.transmission');

const getDesktopUrl = ({ urls }) => {
  return _.get(_.find(urls, x => x.type === DESKTOP), 'url');
};

const toQueryString = query =>
  _.keys(query)
    .filter(key => query[key])
    .map(key => `${key}=${query[key]}`)
    .join('&');

function getSelectedOptions(config) {
  var exteriorColor = getExteriorColor(config);
  var interiorColor = getInteriorColor(config);
  var peg = getPeg(config);

  return _.filter(config.selections.rpos, function(option) {
    return (
      option !== exteriorColor && option !== interiorColor && option !== peg
    );
  }).join('|');
}

function getSelectedOptionsWithColors(config) {
  var peg = getPeg(config);

  return _.filter(config.selections.rpos, function(option) {
    return option !== peg;
  }).join('|');
}

let getEmptyIfContainLocalhost = url =>
  url && url.indexOf('localhost') < 0 ? url : '';

let getDefaultLinks = (appResources, deviceType) => {
  let callToActions = appResources.callToActions;
  let urls = {
    modelselector: _.get(appResources.urls, 'backOutLocationUrl'),
    mobileByo: _.get(appResources.urls, 'mobileBaseUrl'),
    lad: appResources.urls.locateDealerUrl,
    'contact.rep': '',
    lnv: '',
    tia: '',
    'schedule.test.drive': '',
    raq: ''
  };

  callToActions.forEach(function(callToAction) {
    urls[callToAction.key] = _.find(callToAction.urls, {
      type: deviceType
    }).url;
  });

  return urls;
};

let mobilePages = {
  gmc: '/build-and-price.html',
  buick: '/build-your-own.html',
  cadillac: '/build-your-own.html'
};

let normalizeCMSData = (GmdsCmsLinks, state) => {
  var cmsLinks = GmdsCmsLinks && new GmdsCmsLinks();
  var params = state.params;
  var appResources = state.appResources;
  var deviceType = state.deviceType;

  var shoppingLinkUrls = getDefaultLinks(appResources, deviceType);

  var baseUrl = getEmptyIfContainLocalhost(_.get(appResources.urls, 'baseUrl'));
  var isMobile = state.isMobile;

  // Do not use CMS data if running on mobile device and Canada
  if (!(params.country === 'CA' && isMobile)) {
    var classicLink = '';
    var carline = params.carline.toLowerCase();
    var bodystyle = params.bodystyle.toLowerCase();
    var modelyear = params.modelyear.toString();

    try {
      classicLink = cmsLinks.getCmsPageURL(
        'lnv',
        '',
        carline,
        bodystyle,
        modelyear
      );
    } catch (ex) {
      //do nothing. The default is already set
    }
    if (classicLink) {
      const normalizedClassicLink = normalizeClassicLink(classicLink);
      shoppingLinkUrls.lnv = shoppingLinkUrls.lnv.replace(
        '${btlPathname}',
        normalizedClassicLink || 'PATH_NOT_FOUND'
      );
      var index = shoppingLinkUrls.lnv.indexOf('?');
      if (index > -1) {
        shoppingLinkUrls.lnv =
          baseUrl +
          normalizedClassicLink.replace(/^.+\.com/, '') +
          shoppingLinkUrls.lnv.substring(index);
      }

      var url = normalizedClassicLink
        .split('/')
        .slice(0, 3)
        .join('/');

      /* Next, we need to add the correct mobile html page name (which differs per brand) to the end of the url
       segment */

      url = url + mobilePages[params.brand];

      // In pprod, we are seeing some CMS link URLs start with 'http' or an empty string and that will cause .m
      // link to fail.  We haven't seen this issue in prod.  However, it causes problems during QA testing in pprod.
      // So logging the link to console to help debugging.

      if (url === '' || url.match(/^http.*/)) {
        console.warn(
          'Invalid the CMS link URL for building the mobile URL (' +
            url +
            ').  This will cause the .m URL to fail.'
        );
      }

      shoppingLinkUrls.mobileByo += url;
    }
  }
  return shoppingLinkUrls;
};

let getLocateADealerUrl = (urlTemplate, params) => {
  let ladParams = {
    zipcode: _.get(params, 'postalCode'),
    symbolic: 'lad'
  };

  return _.template(urlTemplate)(ladParams);
};

let getViewInventoryUrl = (urlTemplate, params, config) => {
  let lnvParams = {
    zipcode: _.get(params, 'postalCode'),
    color: getExteriorColor(config),
    interior: getInteriorColor(config),
    options: getSelectedOptions(config),
    trimvccode: getTrimvccode(config),
    mmc: getMmc(config),
    peg: getPeg(config),
    ref: 'byo',
    ss: window.location.pathname,
    btlPathname: 'PATH_NOT_FOUND',
    symbolic: 'lnv',
    vehicle:
      _.get(params, 'modelyear') +
      '/' +
      _.get(params, 'carline') +
      '/' +
      _.get(params, 'bodystyle'),
    optionsWithColors: getSelectedOptionsWithColors(config)
  };

  return _.template(urlTemplate)(lnvParams);
};

let getLnvSpeedBump = ctas =>
  _.get(_.find(ctas, cta => cta.key === 'lnv'), 'speedBumpEnabled');

let getScheduleTestDriveUrl = (urlTemplate, params, config, pricing) => {
  let interiorColor = getInteriorColor(config);
  let exteriorColor = getExteriorColor(config);
  let urlParams = {
    mmc: getMmc(config),
    interior: getInteriorColor(config),
    engine: getEngine(config),
    styleId: _.get(config.selections, 'styleId'),
    postalcode: _.get(params, 'postalCode'),
    msrpprice: config.msrp.totalMsrp,
    transmission: getTransmission(config),
    color: getExteriorColor(config),
    netPrice: pricing ? _.get(pricing, 'netPrice') : 0,
    cashbackOffer: pricing ? _.get(pricing, 'incentives.total') : 0,
    driveType: _.get(config.driveType, 'id'),
    rpo: getSelectedOptions(config),
    trimvccode: getTrimvccode(config),
    trimdesc: getTrimDesc(config),
    extcolor: config.options[exteriorColor].primaryName,
    intcolor:
      config.options[interiorColor] && config.options[interiorColor].primaryName
  };
  return _.template(urlTemplate)(urlParams);
};

let getRequestAQuoteUrl = (
  urlTemplate,
  params,
  config,
  unknownPriceText,
  pricing
) => {
  let interiorColor = getInteriorColor(config);
  let exteriorColor = getExteriorColor(config);
  let urlParams = {
    postalcode: _.get(params, 'postalCode'),
    rpo: getSelectedOptions(config),
    trimvccode: getTrimvccode(config),
    trimdesc: getTrimDesc(config),
    extcolor: config.options[exteriorColor].primaryName,
    intcolor:
      config.options[interiorColor] &&
      config.options[interiorColor].primaryName,
    msrpprice: config.msrp.isActualPrice
      ? config.msrp.totalMsrp
      : unknownPriceText,
    mmc: getMmc(config),
    color: exteriorColor,
    interior: interiorColor,
    engine: getEngine(config),
    transmission: getTransmission(config),
    symbolic: 'raq',
    netPrice: pricing ? _.get(pricing, 'netPrice') : 0,
    cashbackOffer: pricing ? _.get(pricing, 'incentives.total') : 0,
    driveType: _.get(config.driveType, 'id')
  };
  return _.template(urlTemplate)(urlParams);
};

const getOCAUrl = (cta, state) => {
  const { params, config } = state;
  const { selections, style, bodyType, msrp, styleId } = config;
  const query = {
    postalcode: params.postalCode,
    year: params.modelyear,
    bodystyle: params.bodystyle,
    carlinecode: params.carline,
    configuration: bodyType.formattedConfig
      ? `${bodyType.formattedConfig} ${selections.driveType}`
      : selections.driveType,
    trim: style.vehicleInfo.code,
    rpocode: selections.rpos.join(','),
    msrp: msrp.totalMsrp,
    freight: msrp.destination,
    actax: msrp.acTax,
    dealerfee: msrp.dealerFee,
    options: msrp.optionsTotal,
    accessories: msrp.accessoriesTotal,
    source: 'gm-byo',
    styleId
  };
  return `${getDesktopUrl(cta)}#?${toQueryString(query)}`;
};

const getSecondaryActions = (
  state,
  unknownPriceText,
  pricing,
  gmwcState = {},
  primaryAction
) => {
  let config = state.config;
  let params = state.params;
  let country = params.country;
  let urls = state.urls;
  let callToActions = state.appResources.callToActions;

  const isCanada = country === 'CA';
  const areFinancingOrLeasingAvailable =
    gmwcState.fshowsum || gmwcState.lshowsum;

  const isCTAEnabled = cta => {
    if (state.isFleet && state.isMobile) {
      // For Fleet mobile case, only show locate a dealer
      return cta.key === 'lad';
    }

    if (state.isFleet) {
      // Hide the "Locate A Dealer" on US Fleet and found match
      if (
        (state.inventory.count && cta.key === 'lad' && country === 'US') ||
        (!state.inventory.count && cta.key === 'contact.rep')
      ) {
        return false;
      }
    } else if (isCanada && state.isMobile && cta.key === 'tia') {
      // Not show the trade-in value CTA if running on Canada retail brands
      return false;
    }

    if (!cta.enabled) {
      return false;
    }

    if (cta.key === 'oca') {
      return areFinancingOrLeasingAvailable;
    }

    return cta.key !== 'lnv';
  };

  const mapCta = (callToAction, index) => {
    let cta = {
      icon: '',
      label: callToAction.label,
      speedBump: callToAction.speedBumpEnabled,
      openNewWindow: isCanada,
      primary: !primaryAction && index === 0 // Primary style when primaryAction is null and first button.
    };

    switch (callToAction.key) {
      case 'raq':
        cta.url = getRequestAQuoteUrl(
          urls[callToAction.key],
          params,
          config,
          unknownPriceText,
          pricing
        );
        cta.icon = 'dollar';
        break;
      case 'lad':
        cta.url = getLocateADealerUrl(urls[callToAction.key], params);
        break;
      case 'schedule.test.drive':
        cta.url = getScheduleTestDriveUrl(
          urls[callToAction.key],
          params,
          config,
          pricing
        );
        break;
      case 'tia':
        cta.url = urls[callToAction.key];
        cta.icon = 'external-link-square';
        break;
      case 'contact.rep':
        cta.url = urls[callToAction.key];
        break;
      case 'oca':
        cta.url = getOCAUrl(callToAction, state);
        break;
    }

    return cta;
  };

  return callToActions.filter(isCTAEnabled).map(mapCta);
};

const getPrimaryAction = (
  state,
  translate,
  options,
  isFamilyFirstUS,
  isFamilyFirstCA
) => {
  const viewInventoryUrlTemplate = state.appResources.vsEmbedded
    ? state.appResources.vsEmbeddedUrl
    : state.viewInventoryUrlTemplate;

  const {
    isFleet,
    isMobile,
    inventory,
    params,
    config,
    appResources,
    locateADealerUrlTemplate,
    contactRepUrl,
    features
  } = state;

  const isFamilyFirst = isFamilyFirstUS || isFamilyFirstCA;

  const speedBump = getLnvSpeedBump(appResources.callToActions);
  const icon = 'locate';
  if (_.get(features, 'disableInventorySummary')) {
    return null;
  }

  if (isFleet && isMobile) {
    return {
      label: translate('component.summary.locate.a.dealer'),
      url: contactRepUrl,
      icon,
      speedBump,
      openNewWindow: false,
      primary: true
    };
  }

  if (inventory.count || isFamilyFirstUS) {
    if (options.enableVehicleShopper && inventory.count) {
      return {
        label: translate('component.summary.locate.vehicle'),
        url: `${viewInventoryUrlTemplate}#?${options.vsParams}&postalcode=${
          params.postalCode
        }`,
        icon,
        speedBump: speedBump || isFamilyFirst,
        openNewWindow: isFamilyFirst,
        primary: true
      };
    }
    if (inventory.count) {
      return {
        label: translate('component.summary.locate.vehicle'),
        url: getViewInventoryUrl(viewInventoryUrlTemplate, params, config),
        icon,
        speedBump: speedBump,
        openNewWindow: isFamilyFirst,
        primary: true
      };
    }
  }

  return {
    label: translate('component.summary.locate.a.dealer'),
    url: isFleet
      ? contactRepUrl
      : getLocateADealerUrl(locateADealerUrlTemplate, params),
    icon,
    speedBump,
    openNewWindow: false,
    primary: true
  };
};

const getCallToActions = (
  state,
  translate,
  pricing,
  gmwcState,
  modelInfo,
  options = { vsParams: '', enableVehicleShopper: false }
) => {
  const { isFamilyFirstUS, isFamilyFirstCA } = modelInfo;
  const primaryAction = getPrimaryAction(
    state,
    translate,
    options,
    isFamilyFirstUS,
    isFamilyFirstCA
  );
  const secondaryActions = getSecondaryActions(
    state,
    translate('unknown.price.text'),
    pricing,
    gmwcState,
    primaryAction
  );
  return primaryAction
    ? [primaryAction].concat(secondaryActions)
    : secondaryActions;
};

export {
  getEmptyIfContainLocalhost,
  getDefaultLinks,
  normalizeCMSData,
  getLocateADealerUrl,
  getViewInventoryUrl,
  getScheduleTestDriveUrl,
  getRequestAQuoteUrl,
  getCallToActions
};
